module.exports = __webpack_public_path__ + "static/img/logo-domain@2x.1360056.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/domain-custom/base/logo-domain@2x.png
// module id = 341
// module chunks = 0